import { use, useEffect, useMemo, useRef, useState } from "react";
import { List } from "react-window";
import CountryList from "./components/CountryList";
import CountryCodeRow from "./components/CountryCodeRow";
import "./index.css";

const ROW_HEIGHT = 42;
const LIST_HEIGHT = 240;

export default function CountryCodeSelect({ value, onChange }) {
    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState("");
    const [code, setCode] = useState({ name: "India", iso2: "in", dialCode: "91", minLength: 10, maxLength: 10 });
    const ref = useRef(null);

    // Close on outside click
    useEffect(() => {
        const handler = e => {
            if (ref.current && !ref.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    useEffect(() => {
        console.log("CountryList", CountryList);
        if(code && value === code.dialCode) return;
        const selected = CountryList.find(c => c.dialCode === value || c.iso2 === value);
        setCode(selected || {});
    }, [value]);

    // Optimized search
    const filteredData = useMemo(() => {
        const q = search.toLowerCase();
        return CountryList.filter(
            c =>
                c.name.toLowerCase().includes(q) ||
                c.dialCode.includes(q)
        );
    }, [search]);

    const onCountryChange = country => {
        setCode(country);
        setOpen(false);
        setSearch("");
        if(onChange) onChange(country);
    }

    console.log("Selected Code:", value, code, CountryList, filteredData);
    return (
        <div className="cc-container" ref={ref}>
            <button className="cc-selected" onClick={() => setOpen(!open)}>
                <img src={`https://flagcdn.com/w20/${code.iso2}.png`} />
                +{code.dialCode}
            </button>
            {open && (
                <div className="cc-dropdown">
                    <input
                        className="cc-search"
                        placeholder="Search country"
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                        autoFocus
                    />

                    {/* Virtualized list */}
                    <List

                        // height={LIST_HEIGHT}
                        // itemCount={filteredData.length}
                        // itemSize={ROW_HEIGHT}
                        // rowProps={{ filteredData }}
                        // overscanCount={6}

                    style={{maxHeight: LIST_HEIGHT}}
                    defaultHeight={200}
                    rowComponent={CountryCodeRow}
                    rowCount={filteredData.length}
                    rowHeight={25}
                    rowProps={{ filteredData, onClick: onCountryChange  }}

                    >
                    </List>
                </div>
            )}
        </div>
    );
}